// src/utils/invoke-channel.ts
var getInvokeChannel = (namespace, event) => `${namespace}:handleInvoke:${event}`;

export {
  getInvokeChannel
};
//# sourceMappingURL=chunk-QL34RJ4Y.js.map